import React from "react";
import IOT from "../../assets/Image/Iot.jpg";

function SuperCharge() {
  return (
    <div className="container mt-5 mb-5">
      <div className="row justify-content-center align-items-center">
        <div className="col-lg-10 col-md-12 col-sm-12 ">
          <h1 className="Text-heading text-center" data-aos="fade-up">
            IoT App Development: Supercharge Innovation Era
          </h1>
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 mt-5 mb-5">
          <img src={IOT} className="img-fluid" alt="" />
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 mt-5 mb-5">
          <p className="text-detail" data-aos="fade-up">
            A decade into revolutionizing the IoT industry, Virtual Tech IoT app
            development services in Dubai are leading the charge. As UAE becomes
            a global powerhouse of technological solutions, we're proud to help
            shape the future, providing unmatched IoT solutions that drive
            business success.
          </p>
          <p className="text-detail" data-aos="fade-up">
            Unleash Potential with our Expert IoT Developers in UAE: Initiate
            your project post an in-depth analysis of your business objectives,
            and let collaborate to skyrocket your revenue. Your journey to
            success starts with Virtual Tech.
          </p>
          <div className="" data-aos="fade-up">
            <button className="btn btn-experts p-3">Contact Us Now</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuperCharge;
